import { render } from "./CheckoutModal.vue?vue&type=template&id=20a64414"
import script from "./CheckoutModal.vue?vue&type=script&lang=js"
export * from "./CheckoutModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__